import { render, staticRenderFns } from "./fuwuMingxi.vue?vue&type=template&id=1c9159cc&scoped=true"
import script from "./fuwuMingxi.vue?vue&type=script&lang=js"
export * from "./fuwuMingxi.vue?vue&type=script&lang=js"
import style0 from "./fuwuMingxi.vue?vue&type=style&index=0&id=1c9159cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9159cc",
  null
  
)

export default component.exports